import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import UsersAdminList from './components/UsersAdminList';
import UsersAdminAddUserPage from './components/UsersAdminAddUserPage';
import UsersAdminGetUserData from './components/UsersAdminGetUserData';

const UsersAdminPage: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="User admin tabs">
        <Tab label="List Users" />
        <Tab label="add User" />
        <Tab label="User data" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <UsersAdminList />}
        {tab === 1 && <UsersAdminAddUserPage />}
        {tab === 2 && <UsersAdminGetUserData />}
      </Box>
    </Box>
  );
};

export default UsersAdminPage;